module.exports = __webpack_public_path__ + "src/assets/img/s-geo.cb89ccd4.svg";